import React, { useState } from 'react';
import './contact.css';
import Avatar from '../Images/s7.png';
import Footer from '../Component/NewFooter';

const offices = [
  {
    name: 'Corporate Headquarter',
    address: '23A/15A Abayomi Shonuga Crescent, Lekki Phase 1, Lagos State, Nigeria.',
    emails: [],
  },
  {
    name: 'Operational Office',
    address: '344 Akhigbe Road, Trans-Amadi Industrial Layout, Port Harcourt 5000101, Rivers State, Nigeria.',
    emails: [],
  },
  {
    name: 'Contact Email',
    address: null,
    emails: ["info@jeyshawnng.com", "jeyshawn2012@gmail.com", "jeyshawn@yahoo.com"],
  },
  {
    name: 'Contact Number',
    address: null,
    emails: [],
    phones: ['+234 8112 790 741'],
  },
];

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Message sent! We will get back to you shortly.');
    setFormData({ name: '', email: '', phone: '', company: '', message: '' });
  };

  return (
    <>
      <div className="img_carrier">
        <img src={Avatar} alt="" />
      </div>

      <section className="contact-section" aria-labelledby="contact-title">
        <div className="contact-section__header">
          <h2 className="contact-section__title" id="contact-title">Get In Touch</h2>
          <hr className="contact-section__divider" />
        </div>

        <hr className="contact-section__rule" />

        <div className="contact-section__body">

          {/* Info Panel */}
          <div className="contact-info">
            {offices.map((office) => (
              <div className="contact-info__office" key={office.name}>
                <h3 className="contact-info__office-name">{office.name}</h3>

                {office.address && (
                  <p className="contact-info__address">{office.address}</p>
                )}

                {office.phones && office.phones.length > 0 && (
                  <ul className="contact-info__phones">
                    {office.phones.map((phone) => (
                      <li key={phone}>Tel: {phone}</li>
                    ))}
                  </ul>
                )}

                {office.emails && office.emails.length > 0 && (
                  <div className="contact-info__email">
                    <span className="contact-info__email-label">Email:</span>
                    {office.emails.map((email) => (
                      <p key={email} className="contact-info__email-value">{email}</p>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Form Panel */}
          <div className="contact-form-panel">
            <h3 className="contact-form__title">Send Message</h3>
            <form onSubmit={handleSubmit} noValidate>
              <div className="contact-form__row">
                <input
                  className="contact-form__input"
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                <input
                  className="contact-form__input"
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="contact-form__row">
                <input
                  className="contact-form__input"
                  type="tel"
                  name="phone"
                  placeholder="Phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
                <input
                  className="contact-form__input"
                  type="text"
                  name="company"
                  placeholder="Company"
                  value={formData.company}
                  onChange={handleChange}
                />
              </div>
              <div className="contact-form__field">
                <textarea
                  className="contact-form__textarea"
                  name="message"
                  placeholder="Message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>
              <button type="submit" className="contact-form__submit">
                Send Message
              </button>
            </form>
          </div>

        </div>
      </section>
      <Footer />
    </>
  );
};

export default Contact;